export const accumulateObjectValues = (object) => {
	let count = 0;
	for (const property in object) {
		count += object[property];
	}
	return count;
}